<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="addOffices">新增科室</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column prop="officesName" label="科室名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-link type="primary" style="margin-right: 20px" @click="editOffices(scope.row)">编辑</el-link>
                            <el-link type="danger" @click="deleteOffices(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog title="新增科室" :visible.sync="dialogAddVisible" width="520px">
            <el-form :model="officesAdd" :rules="addRules" ref="addOffices">
                <el-form-item label="科室名称" label-width="100px" prop="officesName">
                    <el-input v-model="officesAdd.officesName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑科室" :visible.sync="dialogEditVisible" width="520px">
            <el-form :model="officesEdit" :rules="editRules" ref="editOffices">
                <el-form-item label="科室名称" label-width="100px" prop="officesName">
                    <el-input v-model="officesEdit.officesName" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 表格信息
                tableData: [
                    {
                        officesId: '1',
                        officesName: '感冒',
                    }
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增科室弹窗数据
                officesAdd:{
                    officesName: '',
                },
                addRules: {
                    officesName: [{required: true, message: '请输入诊断名称', trigger: 'blur'},],
                },
                // 编辑科室弹窗数据
                officesEdit:{
                    officesName: '',
                },
                editRules: {
                    officesName: [{required: true, message: '请输入诊断名称', trigger: 'blur'},],
                },
            }
        },
        methods: {
            // 获取科室列表
            queryOffices() {
                console.log("aaa")
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.queryOffices();
            },
            // 打开新增科室弹窗
            addOffices() {
                this.dialogAddVisible =true
                this.$nextTick(()=>{
                    this.$refs.addOffices.resetFields();
                });
            },
            // 确定添加科室
            confirmAdd() {
                console.log(this.officesAdd.officesName)
            },
            // 打开编辑科室弹窗
            editOffices(data) {
                this.dialogEditVisible = true
                console.log(data)
                this.officesEdit.officesName = data.officesName
                this.$nextTick(()=>{
                    this.$refs.editOffices.clearValidate();
                });
            },
            // 确认编辑科室
            confirmEdit() {
                console.log(this.officesEdit.officesName)
            },
            // 删除科室
            deleteOffices(date) {
                this.$confirm('您确认要删除此诊断?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message.success('删除成功');
                    // this.axios.post('1000/10016/100023', params,{
                    //     headers:{
                    //         token: this.authorization
                    //     }
                    // }).then(res =>{
                    //     if(res.data.code === 10000) {
                    //         this.$message.success(res.data.message);
                    //         // 查询现有角色
                    //         this.queryRole()
                    //     } else {
                    //         this.$message.error(res.data.message);
                    //     }
                    // }).catch(error => {
                    //     this.$message.error(error);
                    // });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        created() {
            this.queryOffices()
        }
    }

</script>
<style>
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
</style>
